"use client";

import React from "react";
import { Instagram, MapPin, Phone, Mail } from "lucide-react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
function FooterNav() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse" />)}
      </div>;
  }
  return <nav className="flex flex-col gap-4">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-base font-sans text-muted-foreground hover:text-primary transition-colors duration-300 w-fit">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  return <footer data-section-id="22251" id="footer-information" className="dark bg-background text-foreground pt-24 pb-12 relative overflow-hidden border-t border-border/10">
      <div className="dark mx-auto max-w-[1440px] px-[5vw]">
        
        {}
        <div className="mb-16">
          <span className="font-mono text-xs font-medium tracking-[0.2em] uppercase text-muted-foreground">
            § 0X
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8 mb-24">
          
          {}
          <div className="md:col-span-4 flex flex-col items-start">
            <Link to="/" className="mb-8 inline-block">
              <WvcLogo className="h-8 w-auto text-foreground" />
            </Link>
            
            <div className="flex flex-col gap-4 text-sm font-sans text-muted-foreground">
              <div className="flex items-start gap-3">
                <MapPin className="size-4 mt-0.5 shrink-0 text-border" />
                <span>Global Revenue Consultancy</span>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-border" />
                <span>+1 555 012 3456</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-border" />
                <span>hello@hotelrevbaba.com</span>
              </div>
            </div>
          </div>

          {}
          <div className="md:col-span-4 md:col-start-6">
            <h3 className="font-mono text-xs font-medium tracking-[0.2em] uppercase text-foreground mb-6">
              Site Map
            </h3>
            <MenuProvider menu_id="229">
              <FooterNav />
            </MenuProvider>
          </div>

          {}
          <div className="md:col-span-3 flex flex-col items-start md:items-end justify-start">
            <h3 className="font-mono text-xs font-medium tracking-[0.2em] uppercase text-foreground mb-6">
              Follow
            </h3>
            <div className="flex gap-4 mb-8">
              <Button variant="outline" size="icon" className="border-border text-foreground hover:bg-primary hover:text-primary-foreground hover:border-primary transition-all duration-300" asChild>
                <Link to="#" aria-label="Instagram">
                  <Instagram className="size-4" />
                </Link>
              </Button>
            </div>
            
            <div className="mt-auto w-full md:w-auto">
              <p className="font-serif italic text-muted-foreground text-sm mb-4 md:text-right">
                Precision revenue growth.
              </p>
            </div>
          </div>
        </div>

        {}
        <div className="relative w-full h-px bg-border/20 mb-8">
          <div className="absolute left-0 top-0 w-1/3 md:w-1/4 h-px bg-primary">
            <div className="absolute right-0 top-1/2 -translate-y-1/2 size-1 bg-primary" />
          </div>
        </div>

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-xs font-mono text-muted-foreground uppercase tracking-[0.1em]">
          <p>© {new Date().getFullYear()} HOTELREVBABA. ALL RIGHTS RESERVED.</p>
          <div className="flex gap-8">
            <Link to="#" className="hover:text-primary transition-colors duration-300">Privacy</Link>
            <Link to="#" className="hover:text-primary transition-colors duration-300">Legal</Link>
          </div>
        </div>

      </div>
    </footer>;
}